module.exports = __webpack_public_path__ + "img/_0.a4cef0ca.png";